import { createContext, useContext } from 'react';
import type { MyProfile } from '../../data/accounts.ts';
import type { AppError } from '../../data/errors.ts';

export type AuthState =
  | { status: 'loading' }
  | { status: 'signedOut'; reason?: string }
  | { status: 'ready'; profile: MyProfile }
  | { status: 'error'; error: AppError };

export interface AuthApi {
  state: AuthState;
  signIn: (email: string, password: string, captchaToken: string | null) => Promise<string | null>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

export const AuthContext = createContext<AuthApi | null>(null);

export function useAuth(): AuthApi {
  const api = useContext(AuthContext);
  if (!api) throw new Error('useAuth requiere AuthProvider.');
  return api;
}

/** Perfil del usuario autenticado; solo para componentes bajo la ruta protegida. */
export function useProfile(): MyProfile {
  const { state } = useAuth();
  if (state.status !== 'ready') throw new Error('useProfile requiere una sesión lista.');
  return state.profile;
}
